var render = function render(){var _vm=this,_c=_vm._self._c;return _c('print-a4',{attrs:{"is-loading":_vm.isLoading}},[(_vm.data && _vm.data.template)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.template)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }